import { isDate as t } from "date-fns";
function i(r) {
  return typeof r == "object" && r !== null && !Array.isArray(r) && t(r) === !1;
}
export {
  i
};
//# sourceMappingURL=isObject-BWFWCQho.mjs.map
